import "zurb-twentytwenty/css/twentytwenty.css";
import "../../styles/components/_revealer.scss";
import 'zurb-twentytwenty/js/jquery.event.move.js';
import 'zurb-twentytwenty/js/jquery.twentytwenty.js';
import { waitForElements } from '../helpers/utils';
import { isMobile } from '../vue/constants/devices';
export default (($) => {
    console.log('UNTUCKit : Module : Revealer : loaded');
    const initRevealer = () => {
        // when a/b testing via Shogun, element won't be in DOM when this script is run
        waitForElements('.js-revealer').then((el) => {
            $(el).twentytwenty({
                default_offset_pct: 0.51,
                no_overlay: true,
                click_to_move: true,
            });
            initialState();
        }).catch(() => { console.log('Revealer element not available.'); });
    };
    const initialState = () => {
        const beforeImg = $('.twentytwenty-before');
        const afterImg = $('.twentytwenty-after');
        const handle = $('.twentytwenty-handle');
        // only set height/width explicitly in shogun
        if ($('.js-revealer').parents('.shg-c').length) {
            const imgWidth = isMobile() ? 250 : 334;
            const imgHeight = isMobile() ? 440 : 600;
            // prevents twentytwenty determining the height/width is 0 when container is hidden
            beforeImg.width(imgWidth).height(imgHeight);
            afterImg.width(imgWidth).height(imgHeight);
        }
        if (isMobile()) {
            beforeImg.css('clip', 'rect(0px, 127.5px, 440px, 0px)');
            afterImg.css('clip', 'rect(0px, 250px, 440px, 127.5px)');
            handle.css('left', '127.5px');
        }
        else {
            beforeImg.css('clip', 'rect(0px, 175.44px, 600px, 0px)');
            afterImg.css('clip', 'rect(0px, 344px, 600px, 175.44px)');
            handle.css('left', '175.44px');
        }
    };
    const init = () => {
        console.log('UNTUCKit : Module : Revealer : init');
        initRevealer();
    };
    return { init };
})($);
